<template>
    <form action="" @submit.prevent="sendArticle(articleData.nbre)">
      <div class="pa-4 text-center">
      <v-dialog
        v-model="dialog"
        max-width="600"
      >
        <template v-slot:activator="{ props: activatorProps }">
            <!-- <v-icon class="iconplus" icon="mdi-plus" v-bind="activatorProps" ></v-icon> -->
            <v-btn prepend-icon="mdi-plus" v-bind="activatorProps" :disabled="terminer || store.state.articlesFripe.length>0" color="success">
              {{ $t('ajouter') }}
          </v-btn>
        </template>
        <v-card
          :title="$t('ajouter_art')"
        >
          
            <v-card-text>
              <v-row dense>
                <v-col
                  cols="12"
                  md="4"
                  sm="6"
                >
                <v-combobox
                        :label="$t('marques')"
                        :items="itemsmarques"
                        v-model="articleData.marque"
                        variant="outlined" 
                        density="compact"
                        :rules="rules(articleData.marque,`${$t('marques')}`,'-',$i18n.locale,'marque')"
                        :style="[articleData.marque?{'color':'green'}:{'color':'red'}]"
                    ></v-combobox>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  sm="6"
                >
                <v-combobox
                        :label="$t('themes')"
                        :items="itemsThemes"
                        v-model="articleData.theme"
                        variant="outlined" 
                        density="compact"
                        :rules="rules(articleData.theme,`${$t('themes')}`,'-',$i18n.locale,'theme')"
                        :style="[articleData.theme?{'color':'green'}:{'color':'red'}]"
                        :disabled="true"
                    ></v-combobox>
                </v-col>
  
                <v-col
                  cols="12"
                  md="4"
                  sm="6"
                >
                <v-combobox
                        :label="$t('composition')"
                        :items="[`03-${$t('cuir')}`,`06-${$t('synthetique')}`,`44-${$t('textile')}`]"
                        v-model="articleData.composition"
                        variant="outlined" 
                        density="compact"
                        :rules="rules(articleData.composition,`${$t('composition')}`,'-',$i18n.locale,'composition')"
                        :style="[articleData.composition?{'color':'green'}:{'color':'red'}]"
                    ></v-combobox>
                </v-col>
  
                <v-col
                  cols="12"
                  md="4"
                  sm="6"
                >
                  <v-text-field
                    :label="$t('prix_origine')"
                    v-model="articleData.prixAchatOrigine"
                    :disabled="props.ticket?false:true"
                    variant="outlined" 
                    density="compact"
                    prefix="€"
                    :rules="rules(articleData.prixAchatOrigine,`${$t('prix_origine')}`,'^[0-9]*[.,]?[0-9]*$',$i18n.locale,'prixAchatOrigine')"
                    :style="[articleData.prixAchatOrigine?{'color':'green'}:{'color':'red'}]"
                    @change="calculPrixAchat()"
                  ></v-text-field>
                </v-col>
                
                <v-col
                  cols="12"
                  md="4"
                  sm="6"
                >
                <v-combobox
                  :label="$t('rayon')"
                  :items="itemsRayons"
                  :item-title="`libelle_${$i18n.locale}`"
                  item-value="code"
                  v-model="articleData.rayon"
                  variant="outlined" density="compact"
                  :rules="rules(articleData.rayon.libelle_fr,`${$t('rayon')}`,'-',$i18n.locale,'rayon')"
                  :style="[articleData.rayon.code?{'color':'green'}:{'color':'red'}]"
                >
                </v-combobox>
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                  sm="6"
                >
                <v-combobox
                  :label="$t('sous_famille')"
                  :items="itemsSousFamille.filter(el=>el.code.split('')[0]==articleData.rayon.code).sort()"
                  :item-title="`libelle_${$i18n.locale}`"
                  item-value="code"
                  v-model="articleData.sousFamille"
                  variant="outlined" density="compact"
                  :rules="rules(articleData.sousFamille.libelle_fr,`${$t('sous_famille')}`,'-',$i18n.locale,'sousFamille')"
                  :style="[articleData.sousFamille.code?{'color':'green'}:{'color':'red'}]"
                >
                </v-combobox>
                </v-col>
  
                <v-col
                  cols="12"
                  md="4"
                  sm="6"
                >
                <v-combobox
                        :label="$t('couleur')"
                        :items="itemscouleur"
                        v-model="articleData.couleur"
                        variant="outlined" density="compact"
                        :rules="rules(articleData.couleur,`${$t('couleur')}`,'-',$i18n.locale,'couleur')"
                        :style="[articleData.couleur?{'color':'green'}:{'color':'red'}]"
                    ></v-combobox>
                </v-col>
  
                <v-col
                  cols="12"
                  md="4"
                  sm="6"
                >
                <v-combobox
                    :label="$t('grade')"
                    :items="[`A-${$t('excellent_etat')}`,`B-${$t('tres_bon_etat')}`,`C-${$t('bon_etat')}`]"
                    variant="outlined" 
                    density="compact"
                    v-model="articleData.grade"
                    :rules="rules(articleData.grade,`${$t('grade')}`,'-',$i18n.locale,'grade')"
                    :style="[articleData.grade?{'color':'green'}:{'color':'red'}]"
                  ></v-combobox>
                </v-col>
  
                <!-- <v-col
                  cols="12"
                  md="4"
                  sm="6"
                >
                <v-text-field
                    :label="$t('qte')"
                    v-model="articleData.qteCommande"
                    variant="outlined" 
                    density="compact"
                    :rules="rules(articleData.qteCommande,`${$t('qte')}`,'^[0-9]*$',$i18n.locale,'qteCommande')"
                    :style="[articleData.qteCommande?{'color':'green'}:{'color':'red'}]"
                    :disabled="true"
                ></v-text-field>
                
                </v-col> -->
                <v-col
                  cols="12"
                  md="4"
                  sm="6"
                >
                <v-combobox
                    :label="$t('accessoires')"
                    multiple
                    variant="outlined" 
                    density="compact"
                    :items="[`${$t('bandouliere')}`,`${$t('bijoux_de_sac')}`,`${$t('tote_bag')}`,`${$t('autres')}`,`${$t('aucune')}`]"
                    v-model="articleData.accessoires"
                  ></v-combobox>
                
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  sm="6"
                >
                <v-text-field
                    :label="$t('poids')"
                    variant="outlined" 
                    density="compact"
                    placeholder="0.00"
                    prefix="Kg"
                    v-model="articleData.poids"
                    :rules="rules2(articleData.poids,`${$t('poids')}`,'^[0-9]*[.,]?[0-9]*$',$i18n.locale,null)"
                ></v-text-field>
                
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  sm="6"
                >
                <v-text-field
                    :label="$t('dimensions')"
                    v-model="articleData.dimensions"
                    variant="outlined" 
                    density="compact"
                    placeholder="L*H*P"
                    :rules="rules2(articleData.dimensions,`${$t('dimensions')}`,'^[0-9]*[*]*[0-9]*[*]*[0-9]*$',$i18n.locale,null)"
                ></v-text-field>
                
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  sm="6"
                >
                <v-text-field
                    :label="$t('volume')"
                    v-model="articleData.litrage"
                    prefix="L"
                    placeholder="0.00"
                    variant="outlined" 
                    density="compact"
                    :rules="rules2(articleData.litrage,`${$t('volume')}`,'^[0-9]*[.,]?[0-9]*$',$i18n.locale,null)"
                ></v-text-field>
                
                </v-col>

                <v-col
                  cols="12"
                  md="12"
                  sm="6"
                >
                <v-text-field
                    :label="$t('remarque')"
                    variant="outlined" 
                    density="compact"
                    v-model="articleData.remarque"
                ></v-text-field>
                
                </v-col>
                <!-- <v-col
                  cols="12"
                  md="4"
                  sm="6"
                >
                <v-text-field
                    :label="$t('nombre')"
                    v-model="articleData.nbre"
                    variant="outlined" 
                    density="compact"
                    required
                    :rules="rules(articleData.nbre,`${$t('nombre')}`,'^[0-9]*$',$i18n.locale)"
                    :style="[articleData.nbre?{'color':'green'}:{'color':'red'}]"
                    :disabled="true"
                ></v-text-field>
                
                </v-col> -->
                <!-- <v-col
                  cols="12"
                  md="6"
                  sm="6"
                >
                <h4 v-if="props.ticket" style="color:green"> Prix Reprise : €{{ calculPrixAchat() }}</h4>
                
                </v-col> -->
              </v-row>
  
              <small class="text-caption text-medium-emphasis"><span style="color :red">*{{ $t('colonnes_rouges_obligatoires')  }}</span></small>
            </v-card-text>
  
           
            
            <v-divider></v-divider>
  
            <v-card-actions>
              <v-spacer></v-spacer>
  
              <v-btn
                :text="$t('fermer')"
                variant="plain"
                @click="dialog = false"
                color="red"
              ></v-btn>
  
              <v-btn
                color="primary"
                :text="$t('valider')"
                variant="plain"
                 :disabled="!articleData.composition||!articleData.theme||!articleData.marque||!articleData.sousFamille.libelle_fr||!articleData.couleur||articleData.nbre<0||!valid?true:false"
                @click="dialog = false;sendArticle(articleData.nbre)"
                type="submit" 
              ></v-btn>
              <!-- <v-btn 
              class="mt-2" type="submit" @click="addArticles()" block>Submit</v-btn> -->
            </v-card-actions>  
          </v-card>
          
        
      </v-dialog>
  
    </div>
    </form>
    
  </template>
  <script setup>
  import { ref,computed,watch } from 'vue';
  import store from './store';
  import axios from 'axios'
  const props=defineProps({
    terminer:Boolean,
    ticket:Boolean
  })
   let itemsmarques=[
    '1 - OTHER',	'1000 - M0851',	'1002 - NEMO',	'1003 - satch',	'1004 - ANGRY BIRDS',	'1005 - ALL BLACKS',	'1006 - MINNIE',	'1007 - PRINCESS',	'1008 - SPIDERMAN',	'1009 - MICKEY',	'101 - MANDARINA DUCK',	'1010 - PEPE JEANS',	'1011 - REPTILE’S HOUSE',	'1012 - LOLLIPOPS',	'1013 - BEAUMONT',	'1014 - MODALU',	'1015 - ALEXANDER MCQUEEN McQ',	'1016 - ASHTAG',	'1017 - NAPAPIJRI',	'1019 - COLLECTION PRIVEE',	'102 - 145',	'1020 - ANDREA MABIANI',	'1021 - CABIN ZERO',	'1022 - KAPORAL',	'1023 - BESTINI',	'1024 - MARC BY MARC JACOBS',	'1025 - DAVID WILLIAM',	'1026 - PETITE MENDIGOTE',	'1028 - PAJAR',	'1029 - KNIRPS',	'1031 - TAMARIS',	'1032 - BABYBOTTE',	'1033 - MUSTANG',	'1034 - GABOR',	'1035 - SPIRAL',	'1036 - MEPHISTO',	'1037 - BULL BOXER',	'1038 - KHRIO',	'1039 - KOST',	'104 - 147',	'1042 - PALLADIUM',	'1043 - P-L-D-M',	'1044 - JHAY',	'1045 - NO BOX',	'1046 - NALU',	'1047 - HAVAIANAS',	'1048 - UNISA',	'1049 - PANTOFOLA D’ORO',	'1050 - DKNY',	'1051 - WHOOZ',	'1052 - AMERICAN TOURISTER',	'1053 - LES TROPEZIENNES',	'1054 - NOEL',	'1055 - BOPY',	'1056 - LESPORTSAC',	'1057 - FERRARI',	'1060 - NEVADA LOVE',	'1061 - JAPAN RAGS',	'1062 - PLANES',	'1063 - VIOLETTA',	'1064 - SKECHERS',	'1065 - KENNEL/SCHMENGER',	'1066 - STADE TOULOUSAIN',	'1067 - BELLAMY',	'1068 - JEUNE PREMIER',	'1069 - THUNDERCATS',	'1070 - HERSCHEL',	'1071 - ASTER',	'1072 - MELINE',	'1073 - NEW BALANCE',	'1074 - REBECCA MINKOFF',	'1075 - MAISON MARTIN MARGIELA',	'1076 - KARL LAGERFELD',	'1077 - JASON WU',	'1078 - BURBERRY',	'1079 - JOTT',	'1080 - FLO CLO',	'1081 - ANTONYME',	'1082 - DONDERS',	'1083 - BUGATTI',	'1084 - DEELUXE',	'1085 - REINE DES NEIGES',	'1086 - ESCANDELLE',	'1087 - PATRIZIA PEPE',	'1088 - MI PAC',	'1089 - NO NAME',	'109 - PIGANIOL',	'1090 - FILA',	'1091 - MILANO COLLEZIONE',	'1092 - PIPERMARU',	'1093 - MILA LOUISE',	'1094 - INUOVO',	'1095 - MARUTI',	'1096 - MANAS',	'1097 - MA.CRI',	'1098 - PAUL’S BOUTIQUE',	'1099 - BLEU DE CHAUFFE',	'11 - BIASIA FRANCESCO',	'110 - PAQUETAGE',	'1100 - CANADA GOOSE',	'1101 - FUCHS SCHMITT',	'1102 - BASE LONDON',	'1103 - ABRO',	'1104 - ATTENTIF',	'1105 - CHARLIOR',	'1106 - CALVER',	'1109 - MJUS',	'1110 - DR MARTENS',	'1111 - VANS',	'1112 - SPM',	'1113 - VICTORIA',	'1114 - REQINS',	'1115 - PIECES',	'1116 - BUNKER',	'1117 - DANIEL HECHTER',	'1118 - LA MARTINA',	'1119 - FRANCESCO MILANO',	'1122 - SECRID',	'1123 - FROZEN',	'1124 - TEO JASMIN',	'1125 - FEDERAT. FRANCE FOOTBALL',	'1126 - LEON FLAM',	'1127 - KARL MARC JOHN',	'1128 - HAROLD’S',	'1129 - SOFIA',	'113 - POURCHET',	'1130 - LOVE MOSCHINO',	'1131 - Z’ANIMOS',	'1132 - MINIONS',	'1133 - AQUA LEATHER',	'1134 - ROADSIGN',	'1136 - LONGBOARD',	'1137 - PAT PATROUILLE',	'1138 - SAM LE POMPIER',	'1139 - REPETTO',	'1140 - DICKIES',	'1141 - AILEEN',	'1142 - KATE SPADE',	'1143 - PAUL ET JOE SISTER',	'1144 - COACH',	'1145 - KJORE PROJECT',	'1146 - LEGEND',	'1147 - GRAFFITY',	'1148 - LEMON JELLY',	'1149 - FPM',	'1150 - STAR WARS',	'1151 - LAUREN RALPH LAUREN',	'1153 - I CLIP',	'1155 - CYCLEUR DE LUXE',	'1156 - PATRICK',	'1157 - LAMBORGHINI',	'1158 - CHEVROLET',	'1159 - GABS',	'1160 - LILI PETROL',	'1161 - JUSTO',	'1162 - SAVE MY BAG',	'1163 - VERA PELLE',	'1164 - KART',	'1167 - ROSE GARDEN',	'1169 - VANESSA WU',	'117 - 160',	'1170 - TANTREND',	'1171 - PINKISS',	'1172 - BLUE PEARL',	'1173 - REPARATION',	'1174 - ORICE',	'1175 - ONE OF US',	'1176 - COWO',	'1177 - BIRKENSTOCK',	'1178 - VIDOU',	'1179 - ST DUPONT',	'1180 - REAL MADRID',	'1181 - KWELL',	'1182 - VENQUE',	'1183 - AVENGERS',	'1184 - ZOOTOPIA',	'1185 - DORY',	'1186 - CHICA VAMPIRO',	'1187 - LECONS DE CHOSES',	'1188 - POIDS PLUME',	'1189 - EGGMAN',	'1190 - KUTS',	'1191 - FJALLRAVEN',	'1192 - SOY LUNA',	'1193 - TOUS',	'1194 - JACK AND JONES',	'1195 - GEOX',	'1196 - MINIBEL',	'1197 - KANNA',	'1198 - VEJA',	'1199 - HUGO BOSS',	'120 - 163',	'1200 - BOMBERS ORIGINAL',	'1201 - JAYLOUCY',	'1202 - SK8',	'1203 - BURKELY',	'1204 - SELECTED',	'1205 - EXISTENZ',	'1206 - GIPSY',	'1207 - CATCH ME',	'1208 - POLO RALPH LAUREN',	'1209 - CRAZY LOU',	'1210 - UNICEF',	'1211 - CHIARUGI',	'1212 - ARMISTICE',	'1213 - WYLSON',	'1214 - FRODDO',	'1215 - ONLY',	'1216 - PAUL MARIUS',	'1217 - MEEXUP',	'1218 - D.A.T.E',	'1219 - GANADORA',	'122 - PICARD',	'1220 - VIDORRETA',	'1221 - NEUVILLE',	'1222 - SOUVE BAG CO',	'1223 - PLAKTON',	'1224 - TROLLS',	'1225 - THE PACK SOCIETY',	'1226 - VAIANA',	'1227 - YOKAI WATCH',	'1228 - PAW PATROL',	'1229 - AFFENZAHN',	'1230 - MARCIANO',	'1231 - MIRACULOUS',	'1232 - LAISSEZ LUCIE FAIRE',	'1233 - LOVE LOVE',	'1234 - GEORGES RECH',	'1235 - PYRENEX',	'1236 - C.M.P.55',	'1237 - CANADIAN',	'1238 - 0-105',	'1239 - GOLDEN HEAD',	'1240 - LUNDI',	'1241 - STARLING',	'1242 - KDOPA',	'1243 - HOLYSKIN',	'1244 - VILANOVA',	'1245 - UGG',	'1246 - SWISS BAGS',	'1247 - BRENDA ZARO',	'1248 - BILLYBELT',	'1249 - EMPORIO ARMANI',	'1250 - JACADI',	'1251 - SCHMOOVE',	'1252 - RAINS',	'1253 - XD DESIGN',	'1254 - DEERCRAFT',	'1255 - VERO MODA',	'1257 - TONI PONS',	'1258 - MICKEY AND MINNIE MOUSE',	'1259 - KIDZROOM',	'1260 - FILT',	'1261 - THE WHITE BRAND',	'1262 - KOBEN',	'1263 - SANDQVIST',	'1264 - PJMASKS',	'1265 - POKEMON',	'1266 - JP BY JEUNE PREMIER',	'1267 - ANIMAL',	'1268 - SMILEY',	'1269 - EMOJI',	'127 - RONCATO',	'1270 - CARAMEL ET CIE',	'1271 - GOLLA',	'1272 - LES SKEWIES',	'1273 - TORTUES NINJA',	'1274 - DISNEY',	'1275 - NBA',	'1276 - SWEET PANTS',	'1277 - LEGO',	'1278 - BAKKER',	'1279 - MUESLII',	'1280 - BENFICA',	'1281 - LA LICORNE MAGIQUE',	'1282 - CHATTAWAK',	'1283 - E-COW',	'1284 - FOLIE’S',	'1285 - VICTIM',	'1286 - BRONX',	'1287 - LEA TONI',	'1288 - ELISA LANCI',	'1289 - HAPPY SOCKS',	'129 - CARRE ROYAL',	'1290 - BRAND CONNECTION',	'1291 - CABAIA',	'1292 - TED BAKER',	'1293 - ANEKKE',	'1295 - CLIMA',	'1296 - SORUKA',	'1297 - BONS BAISERS DE PANAME',	'1298 - BUFFALO',	'1299 - MAM’ZELLE',	'13 - 019',	'130 - REDSKINS',	'1300 - LE VOYAGE EN PANIER',	'1301 - CARDENAL',	'1302 - ELLESSE',	'1303 - LES SPARTIATES PHOCEENNES',	'1304 - LARMORIE',	'1306 - NASA',	'1307 - BY BRIC’S',	'1308 - DIGEL',	'1309 - PEPPA PIG',	'1311 - THE LION KING',	'1312 - STONES AND BONES',	'1313 - MAGIC SWAN',	'1314 - ALLEZ LES BLEUS',	'1315 - EGGMANIA BY DDP',	'1316 - PUSHEEN',	'1317 - MY FAVORITE',	'1318 - JACK PIERS',	'1319 - LES DEGLINGOS',	'1320 - VANESSA BRUNO',	'1321 - POL FOX',	'1322 - TEST LAURENT',	'1323 - BIBA',	'1324 - FAGUO',	'1325 - SALTED',	'1326 - ECOALF',	'1327 - CARMELA',	'1328 - SPRAYGROUND',	'1329 - SEMERDJIAN',	'1330 - AROGADO BY JUMP',	'1331 - ARCHIPEL',	'1332 - CRAIE',	'1333 - BLACKSTONE',	'1334 - SAC US',	'1335 - DORKING',	'1336 - THE JACKSONS',	'1339 - NATURAL WORLD',	'1340 - ROLAND GARROS',	'1341 - FLUCHOS',	'1342 - MILKY KISS',	'1343 - SKOOTER',	'1344 - STREET',	'1345 - SKY',	'1346 - LOL',	'1347 - GUNS',	'1348 - UCON ACROBATICS',	'1349 - AS98',	'1350 - LAURA VITA',	'1351 - DAVID JONES',	'1353 - AUGRE F',	'1354 - KAPTEN AND SON',	'1355 - HOFF',	'1356 - GIOSEPPO',	'1358 - LA MAISON DE L’ESPADRILLE',	'1359 - SMARTY',	'1361 - BLACKLINES',	'1362 - PREGUNTA',	'1363 - PINKO',	'1364 - MATT ET NAT',	'1365 - REISENTHEL',	'1366 - MERO MERO',	'1367 - WOUF',	'1368 - ARSAYO',	'1369 - DIADORA',	'137 - 186',	'1370 - FITZ AND HUXLEY',	'1372 - PATROUILLE DE FRANCE',	'1373 - ARMANI EXCHANGE',	'1374 - SUPERGA',	'1375 - NATURE IS FUTURE',	'1376 - PARKING',	'1377 - ALLROUNDER',	'1378 - ATOLL PALME',	'1379 - TRIXIE',	'138 - 187',	'1380 - AQTE2',	'1381 - HELLY HANSEN',	'1382 - LE FORMIER',	'1383 - RUCKFIELD',	'1384 - LA COQUE FRANCAISE',	'1385 - HINDBAG',	'1386 - BAGSMART',	'1387 - CHABRAND',	'1388 - TRAVELITE',	'1389 - STEVE MADDEN',	'139 - 188',	'1390 - SAPHIR',	'1391 - MYMA',	'1392 - FLOTTE',	'1393 - COLORS OF CALIFORNIA',	'1394 - ELUE PAR NOUS',	'1395 - METAMORF’OSE',	'1396 - EOLIGEROS',	'1397 - LUNE ET L’AUTRE',	'1398 - WE DO',	'1399 - CACATOES',	'14 - 020',	'140 - CHEVIGNON',	'1400 - GERARD PASQUIER',	'1401 - ALMA EN PENA',	'1402 - ALPE',	'1403 - FEDERAT. FRANCE RUGBY',	'1404 - PRET',	'1406 - HELLO HOSSY',	'1407 - AIGLE',	'1408 - ROCK AND ROSE',	'1409 - ARROBA',	'1411 - BINDI ATELIER',	'1412 - PS POELMAN',	'1413 - CLUSE',	'1415 - NEW ERA',	'1416 - ILSE JACOBSEN',	'1417 - TRIPLUS',	'1418 - GIO+',	'1419 - XAPATAN',	'1420 - MARIE MARTENS',	'1421 - HEY DUDE',	'1422 - CLARKS',	'1423 - VIRGINIE DARLING',	'1424 - HAPPY50',	'1425 - MAC ALYSTER',	'1427 - LILO & STITCH',	'1428 - FORTNITE',	'1429 - VERBENAS',	'143 - 194',	'1430 - LOLA CASADEMUNT',	'1431 - NO BRAND',	'1432 - GORILLA',	'1433 - BY BYBLOS',	'1434 - ALOHAS',	'1435 - NÂ°6',	'1436 - LAURENT DAVID',	'1437 - JEEP',	'1438 - FIFILLE CLUB',	'1439 - MAVERICK',	'1440 - LOUIS VUITTON',	'1441 - PRADA',	'1442 - TOD’S',	'1443 - BLUNDSTONE',	'1444 - KLEMAN',	'1445 - KOST',	'1446 - MOON BOOT',	'1447 - XTI',	'1448 - SOLEX',	'1449 - THE ICONA',	'1450 - TT. BAGATT',	'1451 - MINECRAFT',	'1452 - VIAMAILBAG',	'1453 - FROZEN 2',	'1454 - RIVEDROITE',	'1455 - AUBE',	'147 - TANN’S',	'1501 - TANTA',	'1502 - SUN68',	'1503 - REMONTE',	'1504 - ANOTHER STEP',	'1505 - COOLWAY',	'1506 - CROCS',	'1507 - ALIWELL',	'1508 - MAISON TOUFET',	'1509 - METISSE',	'1510 - MoEa',	'1511 - COCO ABRICOT',	'1512 - GAIMO',	'1513 - NAN-KU COUTURE',	'1514 - NUYOU',	'1515 - ZADIG ET VOLTAIR','1516 - MAJE','1517 - HERMES','1518 - JEAN PAUL GAUTHIER','1519 - SANDRO','1520 - GUCCI',	'161 - MINIPRIX',	'162 - BORDONESE',	'164 - DESCHILDER',	'166 - 230',	'171 - 238',	'173 - PORSCHE DESIGN',	'174 - 243',	'175 - BRIC’S',	'177 - 251',	'18 - 024',	'182 - 259',	'187 - FRANCINEL',	'188 - LANCASTER',	'192 - LONGCHAMP',	'2 - 002',	'200 - COCCINELLE',	'208 - CELINE',	'213 - COURREGES BY EASTPAK',	'217 - CALVIN KLEIN JEANS',	'219 - COLLONIL',	'224 - ARTHUR & ASTON',	'228 - CHRISTIAN LACROIX',	'235 - DELSEY',	'259 - GIL HOLSTERS',	'262 - GIORGIO',	'269 - HEXAGONA',	'27 - 035',	'271 - AGNELLE',	'286 - SEQUOIA',	'296 - SAMSONITE',	'302 - SONIA RYKIEL',	'309 - 953',	'311 - 956',	'315 - TED LAPIDUS',	'316 - THE BRIDGE',	'318 - TEXIER',	'32 - 042',	'323 - JUMP',	'326 - 994',	'331 - QUIKSILVER',	'333 - JANSPORT',	'336 - DDP',	'342 - 813',	'346 - MONTBLANC',	'349 - CHLOE',	'351 - TOSCA BLU',	'353 - 229',	'360 - GLOVE STORY',	'362 - EASTPAK',	'37 - 055',	'38 - FOURES',	'39 - 059',	'397 - LANCEL',	'398 - FURLA',	'405 - TUMI',	'413 - TIMBERLAND',	'416 - 425',	'424 - SNOWBALL',	'432 - YVES RENARD',	'44 - JP GAULTIER',	'458 - 278',	'47 - GERARD HENON',	'48 - 074',	'484 - 705',	'486 - PIQUADRO',	'52 - HERVE CHAPELIER',	'522 - GOLA',	'53 - 080',	'54 - 081',	'55 - ISOTONER',	'551 - LACOSTE',	'577 - BENSIMON',	'578 - IL BISONTE',	'58 - 091',	'595 - NATHAN BAUME',	'602 - HEDGREN',	'615 - RIMOWA',	'627 - 086',	'630 - LUPO',	'631 - BRACCIALINI',	'633 - CRINKLES',	'637 - 212',	'644 - 071',	'647 - TRAVEL',	'651 - JEROME DREYFUSS',	'653 - MANHATTAN PORTAGE',	'654 - PERLETTI',	'667 - PUMA',	'67 - 104',	'68 - 105',	'681 - VICTORINOX',	'684 - OGON',	'694 - GUESS',	'7 - 009',	'70 - KENZO',	'700 - 420',	'706 - BASILIC PEPPER',	'715 - DAYTONA',	'719 - 451',	'720 - 452',	'721 - DIESEL',	'727 - 966',	'73 - KIPLING',	'731 - ETRIER',	'733 - Petit Prix Cuir',	'734 - ROXY',	'736 - TORROW',	'737 - CAMELEON',	'738 - PUCCA',	'739 - DORA',	'74 - LE TANNEUR',	'740 - SPIDER MAN',	'742 - WOOMEN',	'75 - 113',	'755 - ESPRIT',	'758 - CONVERSE',	'760 - HELLO KITTY',	'761 - VON DUTCH',	'764 - CHARLOTTE AUX FRAISES',	'765 - OAKWOOD',	'767 - GIOVANNI',	'768 - ARTURO',	'769 - SKINER’S',	'771 - BIASIA',	'772 - JOST',	'773 - ELITE',	'774 - PAUL ET JOE',	'775 - KATANA',	'778 - VALENTINO',	'78 - OXONE',	'780 - PIERRE CARDIN',	'781 - HAPPY RAIN',	'783 - US',	'785 - SERGE PARIENTE',	'787 - DOLCE GABBANA',	'788 - THIERRY MUGLER',	'790 - CHANTAL THOMASS',	'791 - BENETTON',	'792 - NICA',	'795 - MADISSON',	'798 - JUST CAVALLI',	'799 - GIANFRANCO FERRE',	'8 - KESSLORDdddd',	'800 - LULU CASTAGNETTE',	'801 - PUNTOTRES',	'802 - CARS',	'808 - DESIGUAL',	'809 - DAKINE',	'810 - DC',	'812 - CNC',	'813 - KAPORALS',	'814 - GALLIANO',	'817 - BATMAN',	'820 - COABAN',	'823 - SOFTY',	'825 - JEKEL',	'833 - EUROLINE',	'834 - F',	'835 - GIADA',	'836 - DAVIDT’S',	'838 - GIANNI CHIARINI',	'84 - MOSCHINO',	'840 - SPIRIT',	'841 - BARBARA RIHL',	'844 - GERARD DAREL',	'848 - SERGE BLANCO',	'849 - BAYSIDE',	'856 - FIORELLI',	'859 - KOTHAI',	'86 - 124',	'861 - LITTLE PETSHOP',	'862 - LEATHERFIELD',	'863 - MAC DOUGLAS',	'865 - OMEGA',	'868 - BAKUGAN',	'873 - MENBUR',	'875 - LITTLE MARCEL',	'877 - FOURNITURES',	'878 - LE COQ SPORTIF',	'879 - GABRIEL ANGELI',	'881 - KICKERS',	'882 - GUY DE JEAN',	'884 - TOY STORY',	'886 - OUI OUI',	'889 - TILA MARCH',	'890 - FRAIS DE PORT',	'891 - LE TEMPS DES CERISES',	'892 - JAMIN PUECH',	'893 - MARC JACOBS',	'894 - COCKTAIL',	'895 - GIVENCHY',	'898 - PEAU D’ANE',	'899 - INTUITION',	'9 - YUCATAN',	'900 - VITA',	'904 - AVIATRIX',	'906 - EPIDERM',	'907 - RUITERTASSEN',	'913 - ALEXIS MABILLE',	'916 - Abaco',	'918 - COWBOYSBAG',	'919 - FRANDI',	'923 - BARBIE',	'925 - LEONHARD HEYDEN',	'928 - LIU JO',	'929 - SCHOTT',	'930 - TAGGER',	'931 - ARMANI JEANS',	'932 - FRED PERRY',	'933 - LA POMME DE LOVELEY',	'934 - SUITSUIT',	'935 - VENTIUNO',	'937 - MICHAEL KORS',	'938 - FUCHSIA',	'939 - DUOLYNX',	'940 - Petit Prix Vêtement',	'941 - LEVI’S',	'942 - EDEN PARK',	'944 - MLB/NEW-YORK YANKEES',	'945 - ARMA',	'946 - EDISAC',	'947 - LIPAULT',	'949 - VALERY DAMNON',	'95 - O’NEILL',	'950 - SABRINA',	'954 - LIEBESKIND',	'955 - L’AIGLON',	'956 - LAURAJO',	'962 - MONSTER HIGH',	'963 - IKKS',	'964 - ADIDAS',	'965 - OLYMPIQUE DE MARSEILLE',	'966 - PARIS ST GERMAIN',	'967 - FC BARCELONE',	'968 - LOSC LILLE',	'969 - MILANO',	'970 - IRON MAN',	'971 - LANVIN',	'972 - FOSSIL',	'973 - MELLOW YELLOW',	'975 - MOSHIN ALI',	'978 - LES P’TITES BOMBES',	'979 - SEE BY CHLOE',	'98 - 140',	'980 - GREAT BY SANDIE',	'981 - CERRUTI1881',	'982 - NAT ET NIN',	'984 - VERSACE JEAN’S',	'985 - AZZARO',	'986 - OWN STUFF',	'987 - GALLANTRY',	'989 - Y NOT',	'99 - MONTANA',	'991 - TOMMY HILFIGER',	'993 - RIP CURL',	'994 - LOXWOOD',	'996 - MYSUELLY',	'997 - SUPERDRY',	'999 - SACCOO'
   ]
   let itemsThemes=ref(['PTC-Reprise'])
   let itemsSousFamille=[{code : 'F1A', libelle_fr : 'F1A - Sac bandoulière',libelle_nl :'F1A - Cross body tas'},
   	{code : 'F1B', libelle_fr : 'F1B - Sac porté épaule',libelle_nl :'F1B - Schoudertas'},
    	{code : 'F1C', libelle_fr : 'F1C - Sac porté main',libelle_nl :'F1C - Handtas'},
      	{code : 'F1D', libelle_fr : 'F1D - Sac banane',libelle_nl :'F1D - Heuptasje'},
        	{code : 'F1E', libelle_fr : 'F1E - Sac à dos',libelle_nl :'F1E - Rugzak'},
          	{code : 'F1F', libelle_fr : 'F1F - Sac de cérémomie',libelle_nl :'F1F - Clutch'},
            	{code : 'F1G', libelle_fr : 'F1G - Sac de soirée',libelle_nl :'F1G - Avondtas'},
              	{code : 'F2A', libelle_fr : 'F2A - Porte-monnaie',libelle_nl :'F2A - Portemonnee'},
                	{code : 'F2B', libelle_fr : 'F2B - Portefeuille',libelle_nl :'F2B - Portefeuille'},
                  	{code : 'F2C', libelle_fr : 'F2C - Porte-chéquier',libelle_nl :'F2C - Chequehouder'},
                    	{code : 'F2D', libelle_fr : 'F2D - Tout-en-un',libelle_nl :'F2D - All in one'},
                      	{code : 'F2E', libelle_fr : 'F2E - Porte-clefs',libelle_nl :'F2E - Sleutelhanger'},
                        	{code : 'F2F', libelle_fr : 'F2F - Porte-cartes',libelle_nl :'F2F - Kaarthouder'},
                          	{code : 'F2G', libelle_fr : 'F2G - Porte-papiers',libelle_nl :'F2G - Papierhouder'},
                            	{code : 'F2H', libelle_fr : 'F2H - Étui lunettes',libelle_nl :'F2H - Brilhouder'},
                              	{code : 'F2I', libelle_fr : 'F2I - Étui cigarettes',libelle_nl :'F2I - Sigarettenetui'},
                                	{code : 'F2J', libelle_fr : 'F2J - Étui stylo',libelle_nl :'F2J - Pennenetui'},
                                  	{code : 'F2K', libelle_fr : 'F2K - Étui téléphone',libelle_nl :'F2K - Telefoonetui'},
                                    	{code : 'F2L', libelle_fr : 'F2L - Trousse',libelle_nl :'F2L - Etui'},
                                      	{code : 'F2M', libelle_fr : 'F2M - Agenda',libelle_nl :'F2M - Agenda'},
                                        	{code : 'F2N', libelle_fr : 'F2N - Étui passeport',libelle_nl :'F2N - Paspoorthoes'},
                                          	{code : 'F3A', libelle_fr : 'F3A - Gants',libelle_nl :'F3A - Handschoenen'},
                                            	{code : 'F3B', libelle_fr : 'F3B - Parapluie',libelle_nl :'F3B - Paraplu'},
                                              	{code : 'F3C', libelle_fr : 'F3C - Ceinture',libelle_nl :'F3C - Riem'},
                                                	{code : 'F3D', libelle_fr : 'F3D - Foulard',libelle_nl :'F3D - Foulard'},
                                                  	{code : 'F3E', libelle_fr : 'F3E - Écharpe',libelle_nl :'F3E - Sjaal'},
                                                    	{code : 'F3F', libelle_fr : 'F3F - Chapeau',libelle_nl :'F3F - Hoed'},
                                                      	{code : 'F3G', libelle_fr : 'F3G - Porte sac',libelle_nl :'F3G - Tashaakje'},
                                                        	{code : 'F3H', libelle_fr : 'F3H - Organiseur de sac',libelle_nl :'F3H - Tas organizer'},
                                                          	{code : 'F3I', libelle_fr : 'F3I - Coffret bijoux',libelle_nl :'F3I - Juwelenkoffer'},
                                                            	{code : 'F3J', libelle_fr : 'F3J - Coffret cadeau',libelle_nl :'F3J - Cadeaukoffer'},
                                                              	{code : 'F3K', libelle_fr : 'F3K - Sac provision à roulettes',libelle_nl :'F3K - Boodschappentrolley'},
                                                                	{code : 'F3L', libelle_fr : 'F3L - Sac provision',libelle_nl :'F3L - Boodschappentas'},
                                                                  	{code : 'F3M', libelle_fr : 'F3M - Bijoux',libelle_nl :'F3M - Juwelen'},
                                                                    	{code : 'F3N', libelle_fr : 'F3N - Bijoux de sac',libelle_nl :'F3N - Tashengsel'},
                                                                      	{code : 'F3O', libelle_fr : 'F3O - Bandoulière de sac',libelle_nl :'F3O - Schouderriem'},
                                                                        	{code : 'F3P', libelle_fr : 'F3P - Bonnet',libelle_nl :'F3P - Muts'},
                                                                          	{code : 'F3Q', libelle_fr : 'F3Q - Étole',libelle_nl :'F3Q - Sjaal'},
                                                                            	{code : 'F3R', libelle_fr : 'F3R - Masque lavable',libelle_nl :'F3R - Wasbaar mondmasker'},
                                                                              	{code : 'F3S', libelle_fr : 'F3S - Coque téléphone',libelle_nl :'F3S - Telefoonhoesje'},
                                                                                	{code : 'F3T', libelle_fr : 'F3T - Casquette',libelle_nl :'F3T - Pet'},
                                                                                  	{code : 'F3U', libelle_fr : 'F3U - Chaine coque téléphone',libelle_nl :'F3U - Ketting voor telefoonhoesje'},
                                                                                    	{code : 'F3V', libelle_fr : 'F3V - Bandoulière coque téléphone',libelle_nl :'F3V - Schouderriem voor telefoonhoesje'},
                                                                                      	{code : 'F3W', libelle_fr : 'F3W - Languette',libelle_nl :'F3W - Lipje'},
                                                                                        	{code : 'F3X', libelle_fr : 'F3X - Eventail',libelle_nl :'F3X - Waaier'},
      {code : 'J1A', libelle_fr : 'J1A - Sac à dos', libelle_nl : 'J1A - Rugzak'},
        {code : 'J1B', libelle_fr : 'J1B - Sac à dos à roulettes', libelle_nl : 'J1B - Rugzak op wieltjes'},
          {code : 'J1C', libelle_fr : 'J1C - Cartable', libelle_nl : 'J1C - Boekentas'},
            {code : 'J1D', libelle_fr : 'J1D - Cartable à roulettes', libelle_nl : 'J1D - Boekentas op wieltjes'},
              {code : 'J1E', libelle_fr : 'J1E - Sac gouter', libelle_nl : 'J1E - Lunchtas'},
                {code : 'J1F', libelle_fr : 'J1F - Sac à dos pc', libelle_nl : 'J1F - Business rugzak'},
                  {code : 'J1G', libelle_fr : 'J1G - Sac roulettes', libelle_nl : 'J1G - Tas op wieltjes'},
                    {code : 'J2A', libelle_fr : 'J2A - Sac bandoulière', libelle_nl : 'J2A - Cross body tas'},
                      {code : 'J2B', libelle_fr : 'J2B - Sac porté épaule', libelle_nl : 'J2B - Schoudertas'},
                        {code : 'J2C', libelle_fr : 'J2C - Sac porté main', libelle_nl : 'J2C - Handtas'},
                          {code : 'J2D', libelle_fr : 'J2D - Sac à dos', libelle_nl : 'J2D - Rugzak'},
                            {code : 'J2E', libelle_fr : 'J2E - Sac banane', libelle_nl : 'J2E - Heuptasje'},
                              {code : 'J2F', libelle_fr : 'J2F - Sac de randonnée', libelle_nl : 'J2F - Wandelrugzak'},
                                {code : 'J2G', libelle_fr : 'J2G - Sac de sport', libelle_nl : 'J2G - Sporttas'},
                                  {code : 'J3A', libelle_fr : 'J3A - Porte-monnaie', libelle_nl : 'J3A - Portemonnee'},
                                    {code : 'J3B', libelle_fr : 'J3B - Portefeuille', libelle_nl : 'J3B - Portefeuille'},
                                      {code : 'J3C', libelle_fr : 'J3C - Porte-chéquier', libelle_nl : 'J3C - Chequehouder'},
                                        {code : 'J3D', libelle_fr : 'J3D - Tout-en-un', libelle_nl : 'J3D - All in one'},
                                          {code : 'J3E', libelle_fr : 'J3E - Porte-clefs', libelle_nl : 'J3E - Sleutelhanger'},
                                            {code : 'J3F', libelle_fr : 'J3F - Porte-cartes', libelle_nl : 'J3F - Kaarthouder'},
                                              {code : 'J3G', libelle_fr : 'J3G - Trousse', libelle_nl : 'J3G - Pennenzak'},
                                                {code : 'J4A', libelle_fr : 'J4A - Parapluie', libelle_nl : 'J4A - Paraplu'},
                                                  {code : 'J4B', libelle_fr : 'J4B - Ceinture', libelle_nl : 'J4B - Riem'},
                                                    {code : 'J4C', libelle_fr : 'J4C - Coffret bijoux', libelle_nl : 'J4C - Juwelenkoffer'},
                                                      {code : 'J4D', libelle_fr : 'J4D - Coffret cadeau', libelle_nl : 'J4D - Cadeaukoffer'},
                                                        {code : 'J4E', libelle_fr : 'J4E - Led', libelle_nl : 'J4E - Led'},
                                                          {code : 'J4F', libelle_fr : 'J4F - Pochette', libelle_nl : 'J4F - Ritsvak'},
                                                            {code : 'J4G', libelle_fr : 'J4G - Papeterie', libelle_nl : 'J4G - Papierwaren'},
                                                              {code : 'J4H', libelle_fr : 'J4H - Gourde', libelle_nl : 'J4H - Drinkfles'},
                                                                {code : 'J4I', libelle_fr : 'J4I - Rabat amovible', libelle_nl : 'J4I - Afneembare flap'},
                                                                  {code : 'J4J', libelle_fr : 'J4J - Casquette', libelle_nl : 'J4J - Pet'},
                                                                    {code : 'J4K', libelle_fr : 'J4K - Pièces détachées', libelle_nl : 'J4K - Wisselstukken'}]

   let itemscouleur=store.state.itemColors
   let itemsRayons=[
    {code : 'F', libelle_fr : 'F - FEMME', libelle_nl : 'F - VROUW'},
    {code : 'J', libelle_fr : 'J - JEUNE SCOLAIRE', libelle_nl : 'J - SCHOOLGAANDE JEUGD'}
   ]
   let prixPVC=computed(()=>{
    return articleData.value.prixAchat&&props.ticket?Number(articleData.value.prixAchat*1.8).toFixed(1):0
   })
   let prixAchatOrigine=ref()
   let prixAchat=computed(()=>{
    let prix=0
    if(articleData.value.grade&&props.ticket){
      switch (articleData.value.grade.split('-')[0].trim()){
        case "A":  prix= articleData.value.prixAchatOrigine?Number(Number(articleData.value.prixAchatOrigine.toString().replace(',','.'))*0.35).toFixed(1):0
        break
        case "B":  prix= articleData.value.prixAchatOrigine?Number(Number(articleData.value.prixAchatOrigine.toString().replace(',','.'))*0.30).toFixed(1):0
        break
        case "C": prix= articleData.value.prixAchatOrigine?Number(Number(articleData.value.prixAchatOrigine.toString().replace(',','.'))*0.25).toFixed(1):0
        break
      }
    }
    return prix
   })
  //  //console.log(composition.value);
   function gererateEAN13(){
    
      let ean=Number(store.state.cab)+10
      let ean13=ean.toString().substring(0,12)
      let c=Number(ean13[0])+Number(ean13[2])+Number(ean13[4])+Number(ean13[6])+Number(ean13[8])+Number(ean13[10])
      let b= 3*(Number(ean13[1])+Number(ean13[3])+Number(ean13[5])+Number(ean13[7])+Number(ean13[9])+Number(ean13[11]))
      let cle=(10-(b+c)%10)%10
      return ean13+cle.toString()
    }

   let articleData=ref({
      marque:null,
      theme:'PTC-Reprise',
      grade:null,
      composition:null,
      codeFournisseur:null,
      rayon:{code:null,libelle_fr:null,libelle_nl:null},
      sousFamille:{code:null,libelle_fr:null,libelle_nl:null},
      couleur:null,
      qteCommande:1,
      accessoires:null,
      poids:null,
      dimensions:null,
      litrage:null,
      prixAchatOrigine:null,
      remarque:null,
      nbre:1,
   })
   let article=computed(()=> {
      return {
        pole:'SecondLife',
        refFourn:  `${prixPVC.value}-${articleData.value.composition?articleData.value.composition.split('-')[1].substring(0, 1):''}-${articleData.value.sousFamille.code?articleData.value.sousFamille.code:''}`,
        nomProduit: `${prixPVC.value}-${articleData.value.composition?articleData.value.composition.split('-')[1].substring(0, 1):''}-${articleData.value.sousFamille.code?articleData.value.sousFamille.code:''}`,
        marque:  articleData.value.marque,
        theme:  articleData.value.theme,
        grade:  articleData.value.grade,
        composition:  articleData.value.composition,
        prixPublicTTC:  prixPVC.value,
        sousFamille:  articleData.value.sousFamille.libelle_fr,
        libCouleur:  articleData.value.couleur,
        prixAchatHT:  prixAchat.value,
        qteCommande:  articleData.value.qteCommande,
        accessoires:  articleData.value.accessoires,
        poidnet:  articleData.value.poids,
        dimensions:  articleData.value.dimensions,
        litrage:  articleData.value.litrage,
        prixAchatOrigine  :props.ticket?Number(articleData.value.prixAchatOrigine.toString().replace(',','.')):0,
        codeFournisseur:  articleData.value.codeFournisseur,
        remarque:  articleData.value.remarque,
        totalBrut:  props.ticket&&articleData.value.qteCommande&&prixAchat?articleData.value.qteCommande*prixAchat.value:0,
        coefBrut:  props.ticket&&prixAchat.value&&prixPVC.value?Number(prixPVC/prixAchat.value).toFixed(2):0,
        totalPVpublic:  props.ticket&&articleData.value.qteCommande&&prixPVC?articleData.value.qteCommande*prixPVC.value:0,
        nbre: articleData.value.nbre
      }
   })
  //  let sum=(object,value)=>{
  //   let sum=0
  //   for(key in object){
  //     sum=sum+key
  //   }
  //  }
  let articleValide=ref({
    marque:false,
    composition:false,
    sousFamille:false,
    couleur:false,
    grade:false
  })
  let valid=ref(true)
  // watch(
  //       axe,
  //       (newValue, oldValue) => {
  //           chartData2()
  //       },
  //       { deep: true } // Important pour surveiller les changements dans l'objet
  //   )
  watch(
    articleValide,
    ()=>{
      valid.value=articleValide.value.grade&&articleValide.value.couleur&&articleValide.value.sousFamille&&articleValide.value.composition&&articleValide.value.marque
    },
    { deep: true } 
  )

   let rules=(value,libelle,reg,locale,validation)=>{
    let regex = new RegExp(reg)
    if (value){
      if(value.toString().match(regex)){
        articleValide.value[validation]=true
        return [true]
      } else{
        articleValide.value[validation]==false
        if(libelle.match(/(Lib couleur|marques|Grade|Composition)/gmi)){
          return [locale=='fr'?`Selectionnez ${libelle} de la liste`:`Kies ${libelle} uit de lijst`]
        }else{
          return [locale=='fr'?`Le ${libelle} n'est pas en bon format`:`De ${libelle} heeft niet het juiste formaat`]
        }
        
      }
    }
    else{
      articleValide.value[validation]==false
      return [locale=='fr'?`Vous devez renseigner le ${libelle}`:`U moet de ${libelle} invullen`]
    }
      
  }
  let rules2=(value,libelle,reg,locale,validation)=>{
    let regex = new RegExp(reg)
    if (value){
      if(value.toString().match(regex)){
        articleValide.value[validation]==true
        return [true]
      } else{
        articleValide.value[validation]==false
        return [locale=='fr'?`Le ${libelle} n'est pas en bon format`:`De ${libelle} heeft niet het juiste formaat`]
      }
    }
  }
  let prixRepriseHt=ref()
    const calculPrixAchat=()=>{
      return prixAchat.value
      // console.log(prixRepriseHt.value);
      
     }     
            
  async function addArticles(nbre){
  
    await getID()
    await getCAB()
    // console.log('add',article.value);
    for(let i=0 ;i<nbre;i++){
      store.commit('addRowArticle',{...article.value,id:'FRI-'+(store.state.countId++).toString().padStart(6,"0")+articleData.value.couleur.split('-')[0],
      cab:gererateEAN13()})
      store.commit('updateglobalID',store.state.countId)
      store.commit('updateCAB',gererateEAN13())
    }

    sendGlobalID()
    sendCAB()
    
    }
    const dialog=ref(false)
    const ordered=(referenced) =>{
      return referenced.sort().reduce(
          (a,b)=>a>b?1:-1
        );
    }

  function getID(){  
    let url=    `https://my.edisac.com/api/getID`
    // console.log(url)
    let config = {
    method: 'get',
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
    },
    url: url
    };
    return   axios.request(config)
    .then((response) => {
        store.commit('updateglobalID',response.data)
    })
    .catch((error) => {
    //console.log(error);
    });

  }
  const sendGlobalID=()=>{
    let data = {countId:store.state.countId}
    let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/getID',
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
    },
    data : data
    }
    return axios.request(config)
    .then((response) => { 
        // console.log(response);
        
    })
    .catch((error) => {
    //console.log(error);
    });
  }
  const sendArticle=()=>{
    
    let data ={article:article.value}
    // let data ={test:'test',test2:'TEST2'}
    //console.log(data);
    
    let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/getArticle',
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
    },
    data : data
    }
    return axios.request(config)
    .then((response) => { 
        //console.log(response);
        for(let i=0;i<response.data.length;i++){
          store.commit('addRowArticle',response.data[i])
        }
        
        
    })
    .catch((error) => {
    //console.log(error);
    });
  }
  

  function getCAB(){  
    let url=    `https://my.edisac.com/api/cab`
    // console.log(url)
    let config = {
    method: 'get',
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
    },
    url: url
    };
    return   axios.request(config)
    .then((response) => {
      store.commit('updateCAB',response.data)   
    })
    .catch((error) => {
    //console.log(error);
    });
  }
  const sendCAB=()=>{
    
    let data = {cab:store.state.cab}
    
    let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/cab',
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
    },
    data : data
    }
    return axios.request(config)
    .then((response) => { 
        // console.log(response);
        
    })
    .catch((error) => {
    //console.log(error);
    });
  }


  
  
  </script>
  